import { RouterProvider } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { lightTheme } from "./theme";
import { GlobalStyle } from "./theme/GlobalStyle";
import useAuth from "./hooks/useContexts";
import { useEffect } from "react";
import { SkeletonTheme } from "react-loading-skeleton";
import { routes } from "./routes";

type themeType = typeof lightTheme;

function App() {
  const { setAuth } = useAuth();
  console.log(import.meta.env.VITE_BACKEND_BASE_URL, "backend base url");

  useEffect(() => {
    // Token and user are persisted with JSON.stringify (see login / PersistLogin),
    // so they must be parsed the same way here — reading the token raw yields a
    // quoted string and produces a malformed `Bearer "<token>"` header.
    const safeParse = (value: string | null) => {
      try {
        return value ? JSON.parse(value) : null;
      } catch {
        return null;
      }
    };

    try {
      const token = safeParse(localStorage.getItem("token")) || "";
      const user = safeParse(localStorage.getItem("user")) || {};
      setAuth({ token, user });
    } catch (e: any) {
      console.log(e.message);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Disable scroll that changes number values app wide
  // @ts-ignore
  document.addEventListener("wheel", function (event) {
    try {
      if (
        (document.activeElement as HTMLInputElement)?.type === "number" &&
        !document.activeElement?.classList?.contains("noscroll")
      ) {
        (document.activeElement as HTMLElement)?.blur();
      }
    } catch (e: any) {
      console.log(e.message);
    }
  });

  return (
    <ThemeProvider theme={lightTheme}>
      <SkeletonTheme baseColor="#202020" highlightColor="#444">
        <GlobalStyle />
        <RouterProvider router={routes} />
      </SkeletonTheme>
    </ThemeProvider>
  );
}

export type { themeType };
export default App;
